import * as React from 'react';
import styled from 'styled-components';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Input } from '@monavate/ui-core';

const AmountRangeFilterSchema = yup.object().shape({
    min: yup
        .number()
        .typeError('Must be a number')
        .transform((value, originalValue) => {
            if (originalValue === '') return null;
            return value;
        })
        .test('not more than max', 'Must be less or equal Max value', function (value) {
            const max = this.parent.max;
            if (max && value) {
                return max >= value;
            } else {
                return true;
            }
        })
        .notRequired()
        .min(0, 'Should be more than 0'),
    max: yup
        .number()
        .typeError('Must be a number')
        .transform((value, originalValue) => {
            if (originalValue === '') return null;
            return value;
        })
        .test('not less than min', 'Must be more or equal Min value', function (value) {
            const min = this.parent.min;
            if (min && (value || typeof value === 'number')) {
                return value >= min;
            } else {
                return true;
            }
        })
        .notRequired()
        .min(0, 'Should be more than 0'),
});

const Wrapper = styled.div`
    display: flex;
    gap: 32px;
`;

const transformDefaultValueToSchemaValue = (defaultValue: any[]) => {
    let min = undefined;
    let max = undefined;
    if (defaultValue.length > 0) {
        min = +defaultValue[0];
        max = +defaultValue[1];
    }
    return {
        min,
        max,
    };
};

interface AmountRangeInputsProps {
    onChangeCallback: any;
    defaultValues: any;
    setsIsAmountValid: (isValid: boolean) => void;
}

const AmountRangeInputs: React.FC<AmountRangeInputsProps> = ({
    onChangeCallback,
    defaultValues,
    setsIsAmountValid,
}) => {
    const {
        register,
        watch,
        setValue,
        formState: { errors, isValid },
        trigger,
    } = useForm({
        resolver: yupResolver(AmountRangeFilterSchema),
        mode: 'all',
        defaultValues: transformDefaultValueToSchemaValue(defaultValues),
    });

    const minWatched = watch('min');
    const maxWatched = watch('max');

    useEffect(() => {
        setsIsAmountValid(isValid);
    }, [isValid]);

    useEffect(() => {
        trigger(['min', 'max']);
        if (!minWatched && !maxWatched) {
            onChangeCallback([]);
        } else {
            const min = minWatched || 0;
            const max = maxWatched || 1000000;
            onChangeCallback([min, max]);
        }
    }, [minWatched, maxWatched]);

    useEffect(() => {
        if (defaultValues?.length == 0) {
            setValue('min', undefined);
            setValue('max', undefined);
        }
    }, [defaultValues]);

    return (
        <Wrapper>
            <Input
                min={0}
                placeholder={'Min'}
                name={'min'}
                register={() => register('min')}
                error={errors?.min?.message}
            />
            <Input
                min={0}
                placeholder={'Max'}
                name={'max'}
                register={() => register('max')}
                error={errors?.max?.message}
            />
        </Wrapper>
    );
};

export default AmountRangeInputs;
